import { Course } from "@models/ISchema";
import { LABORATORY_COURSE_TYPE } from "@services/constants/references";

export const getTotalDemandVacancies = (course: Course) => {
  if (!!course.demand?.crosslist) {
    let hasAddedDemandVacancies = false;

    const totalVacancies = course?.crosslistDemands?.reduce((acc, demand) => {
      if (demand?.id === course?.demand?.id) {
        hasAddedDemandVacancies = true;
      }

      return acc + (demand?.vacancies ?? 0);
    }, 0);

    return totalVacancies + (hasAddedDemandVacancies ? 0 : (course?.demand?.vacancies ?? 0));
  }

  return course.demand?.vacancies;
};

export const isCourseTypeForAssignationOrProgramming = (courseType = "") => {
  return ["BLOQUE", "CONCENTRACIÓN", "CONCENTRACION"].includes((courseType ?? "")?.toUpperCase());
};

/**
 * A course is a laboratory only when its type is exactly "Laboratorio", ignoring case and
 * surrounding whitespace (CHS-2974 AC1). Variants such as "LAB" or "LABORATORIO 1" and an
 * undetermined type (null, empty, non-string) are not laboratories (AC5).
 */
export const isLaboratoryCourseType = (courseType?: string | null): boolean =>
  typeof courseType === "string" && courseType.trim().toLowerCase() === LABORATORY_COURSE_TYPE;
